import React from 'react';
import { Link } from 'react-router-dom';
import '../_components/components.css';

export default function DeleteAccount() {
  return (
    <div className="global_container" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      {/* Premium Header */}
      <header className="header_component ltrtext shadow-sm" dir="ltr" style={{ backgroundColor: '#ffffff', height: '80px' }}>
        <div className="container navbar py-0">
          <Link to="/" className="navbar-brand">
            <img className="login_main_logo" src="/img/edraak_logo.png" alt="edraak online logo" style={{ height: '45px' }} />
          </Link>
          <Link to="/" className="btn btn-outline-primary btn-sm rounded-pill px-4">Back to Home</Link>
        </div>
      </header>

      <main className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8">
            <div className="bg-white rounded-4 shadow-sm overflow-hidden border">
              {/* Header Banner */}
              <div className="bg-primary p-4 p-md-5 text-white text-center">
                <div className="mb-3">
                  <span className="display-4" role="img" aria-label="shield">🛡️</span>
                </div>
                <h1 className="h2 mb-2" style={{ fontWeight: 800, letterSpacing: '-0.5px' }}>Delete Account & Data</h1>
                <p className="opacity-75 mb-0">Manage your privacy and data deletion requests</p>
              </div>

              <div className="p-4 p-md-5">
                <section className="mb-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="bg-primary-subtle p-2 rounded-3 me-3 text-primary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                      </svg>
                    </div>
                    <h2 className="h4 mb-0 text-dark fw-bold">Overview</h2>
                  </div>
                  <p className="text-secondary leading-relaxed">
                    This page explains how to request the deletion of your <strong>edraak online</strong> account and all associated personal data. We take your privacy seriously and ensure that your data is handled securely throughout the process.
                  </p>
                </section>

                <section className="mb-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="bg-primary-subtle p-2 rounded-3 me-3 text-primary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-envelope-check-fill" viewBox="0 0 16 16">
                        <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
                      </svg>
                    </div>
                    <h2 className="h4 mb-0 text-dark fw-bold">How to Request Deletion</h2>
                  </div>
                  <p className="text-secondary">
                    You can submit a deletion request by contacting our support team via email.
                  </p>
                  
                  <div className="bg-light p-4 rounded-4 border border-primary border-opacity-10 text-center my-4 shadow-sm">
                    <p className="text-muted mb-2 small text-uppercase fw-bold tracking-wider">Send an email to</p>
                    <a href="mailto:info@edraakonline.com" className="h4 d-block text-primary text-decoration-none fw-bold mb-3 hover-opacity">
                      info@edraakonline.com
                    </a>
                    <div className="pt-3 border-top border-2 border-white">
                      <p className="mb-1 text-muted small">Subject line:</p>
                      <p className="fw-bold text-dark mb-0">Account Deletion Request</p>
                    </div>
                  </div>

                  <div className="card bg-white border-0 shadow-sm rounded-4 p-4">
                    <h3 className="h6 fw-bold text-dark mb-3">Required details in your email:</h3>
                    <ul className="list-group list-group-flush small">
                      <li className="list-group-item d-flex align-items-center border-0 px-0">
                        <span className="bg-success rounded-circle p-1 me-2"><svg width="10" height="10" fill="white" viewBox="0 0 16 16"><path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/></svg></span>
                        Registered phone number or email address
                      </li>
                      <li className="list-group-item d-flex align-items-center border-0 px-0">
                        <span className="bg-success rounded-circle p-1 me-2"><svg width="10" height="10" fill="white" viewBox="0 0 16 16"><path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/></svg></span>
                        Application name: <strong>edraak online</strong>
                      </li>
                      <li className="list-group-item d-flex align-items-center border-0 px-0">
                        <span className="bg-success rounded-circle p-1 me-2"><svg width="10" height="10" fill="white" viewBox="0 0 16 16"><path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/></svg></span>
                        Reason for deletion (optional)
                      </li>
                    </ul>
                  </div>
                </section>

                <section className="mb-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="bg-primary-subtle p-2 rounded-3 me-3 text-primary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-1.31 5.637a5.53 5.53 0 0 1-8.141-1.424l1.314-1.313a4.03 4.03 0 0 0 5.922 1.042l1.305 1.305a.25.25 0 0 1 0 .354zM4.466 9H.534a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36A.25.25 0 0 1 4.466 9zm1.31-5.637a5.53 5.53 0 0 1 8.141 1.424l-1.314 1.313a4.03 4.03 0 0 0-5.922-1.042L5.376 3.013a.25.25 0 0 1 0-.354z"/>
                      </svg>
                    </div>
                    <h2 className="h4 mb-0 text-dark fw-bold">The Process</h2>
                  </div>
                  <div className="row g-4">
                    <div className="col-sm-4">
                      <div className="text-center p-3 h-100 bg-light rounded-4">
                        <div className="h3 text-primary mb-2">1</div>
                        <p className="small mb-0 fw-bold">Identity Verification</p>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="text-center p-3 h-100 bg-light rounded-4">
                        <div className="h3 text-primary mb-2">2</div>
                        <p className="small mb-0 fw-bold">Permanent Deletion</p>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="text-center p-3 h-100 bg-light rounded-4">
                        <div className="h3 text-primary mb-2">3</div>
                        <p className="small mb-0 fw-bold">Final Completion</p>
                      </div>
                    </div>
                  </div>
                  <p className="mt-4 text-secondary small">
                    The entire process is typically completed within <strong>7–30 working days</strong> from the date of identity verification.
                  </p>
                </section>

                <section className="mb-5 bg-light p-4 rounded-4 border-start border-4 border-warning">
                  <h2 className="h5 mb-3 text-dark fw-bold">Data Retention Notice</h2>
                  <p className="small text-secondary mb-0">
                    While we delete most personal data, we are legally required to retain some information:
                    <br /><br />
                    • <strong>Legal Obligations:</strong> Invoices and transaction records.
                    <br />
                    • <strong>Financial Records:</strong> Billing records may be retained for up to 7 years to comply with tax laws.
                  </p>
                </section>

                <section>
                  <h2 className="h4 mb-4 text-dark fw-bold text-center">Contact Information</h2>
                  
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="h-100 p-4 bg-white border rounded-4 shadow-sm">
                        <p className="text-primary fw-bold mb-3">Office Address</p>
                        <p className="text-dark small mb-0">
                          <strong>edraak online</strong><br />
                          VO/463, 68/1520 2nd Floor,<br />
                          CM Mathew Brother Arcade,<br />
                          Eranhipalam, Kozhikode-673006
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="h-100 p-4 bg-white border rounded-4 shadow-sm">
                        <p className="text-primary fw-bold mb-3">Support Channels</p>
                        <p className="small mb-2">
                          <span className="text-muted">Email:</span><br />
                          <a href="mailto:info@edraakonline.com" className="text-dark fw-bold text-decoration-none">info@edraakonline.com</a>
                        </p>
                        <p className="small mb-0">
                          <span className="text-muted">Phone:</span><br />
                          <a href="tel:+91889101999" className="text-dark fw-bold text-decoration-none">+91 889101999</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <div className="p-4 bg-light text-center border-top">
                <p className="small text-muted mb-0">
                  For more information, please read our <a href="https://edraakonline.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-primary fw-bold text-decoration-none">Privacy Policy</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="footer w-100 py-4 mt-auto border-top bg-white">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
          <img className="login_header_logo" src="/img/edraak_logo.png" alt="edraak online logo" style={{ height: '30px' }} />
          <div className="d-flex gap-4">
            <a href="https://edraakonline.com/terms-and-condition/" className="text-secondary small text-decoration-none hover-primary">Terms of Use</a>
            <a href="https://edraakonline.com/privacy-policy/" className="text-secondary small text-decoration-none hover-primary">Privacy Policy</a>
          </div>
        </div>
      </footer>
      
      <style>{`
        .hover-opacity:hover { opacity: 0.8; }
        .hover-primary:hover { color: var(--bs-primary) !important; }
        .leading-relaxed { line-height: 1.6; }
        .tracking-wider { letter-spacing: 0.05em; }
        .bg-primary-subtle { background-color: rgba(13, 110, 253, 0.1); }
      `}</style>
    </div>
  );
}
